module.exports = __webpack_public_path__ + "c035e4dd565cc8200f131a68969b8523.svg";